import { Component, EventEmitter, Output } from '@angular/core';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';

import { CommonService } from '../../navbar/searchCommon.service';
import { SharedService } from '../../shared/shared.service';


@Component({
    selector: 'basic-search-model',
    templateUrl: './basicsearch.component.html',
    styleUrls: ['./basicsearch.component.css']
  })
export class BasicSearchComponent {

    showCarotbool: boolean = false;
    private subscription: Subscription;

    searchTerm = '';
    searchArea = 'Projects'; // Should detect current page to choose this
    haveNewSearchData: boolean = false;

    @Output() OpenAdvancedSearchAction = new EventEmitter();

    constructor(private router: Router, private commonService: CommonService, private service: SharedService) { }

    ngOnInit() {
        this.router.events.subscribe((val) => {
            this.searchTerm = '';
            this.showCarotbool = false;
            
            if (this.router.url === '/projects') {
                this.searchArea = 'Projects';
            } else if (this.router.url === '/quote') {
                this.searchArea = 'Quotes';
            } else {
                this.searchArea = 'Projects';
            }
        });
        this.subscription = this.commonService.notifyObservable$.subscribe((res) => {
           if (res.hasOwnProperty('option') && res.option === 'getPageSearchData') {
                if (this.haveNewSearchData) {
                    this.haveNewSearchData = false;
                    switch (this.searchArea) {
                        case 'Projects':
                            this.commonService.notifyOther({
                                option: 'onSearchFromNav',
                                value: {page: 'projects', data: this.searchTerm}
                            });
                        break;
                        case 'Quotes':
                            this.commonService.notifyOther({
                                option: 'onSearchFromNav',
                                value: {page: 'quotes', data: this.searchTerm}
                            });
                        break;
                    }
                }

            }
        });
    }
    showCarot() {
        this.showCarotbool = true;
    }

    clearSearch() {
        this.searchTerm = '';
        this.showCarotbool = false;
        switch (this.searchArea) {
            case 'Projects':
            this.commonService.notifyOther({ option: 'onSearchFromNav', value: {page: 'projects', data: '' }});
            break;
            case 'Quotes':
            this.commonService.notifyOther({ option: 'onSearchFromNav', value: {page: 'quotes', data: '' } });
            break;
        }
    }

    doSearch() {
        switch (this.searchArea) {
            case 'Projects':
                // if we're already on the page do the call to get search results
                if (this.router.url === '/projects') {
                    this.commonService.notifyOther({
                        option: 'onSearchFromNav',
                        value: {page: 'projects', data: this.searchTerm}
                    });
                } else {
                    this.haveNewSearchData = true;
                    this.service.setProjectSearchResultBool(true);
                    this.router.navigate(['/projects']);
                }
            break;
            case 'Quotes':
                // if we're already on the page do the call to get search results
                if (this.router.url === '/quote') {
                    this.commonService.notifyOther({
                        option: 'onSearchFromNav',
                        value: {page: 'quotes', data: this.searchTerm}
                    });
                } else {
                    this.haveNewSearchData = true;
                    this.service.setQuoteSearchResultBool(true);
                    this.router.navigate(['/quote']);
                }
            break;
        }
    }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/search/basic/basicsearch.component.ts